export default __webpack_public_path__ + "static/media/hero-background.d74391d4.png";